export default __webpack_public_path__ + "static/media/sari (2).a44e7328.jpeg";